import React from "react";

import PhoneNumber from "../../types/core/PhoneNumber";
import NumberTypes from "../../types/enums/NumberTypes";

import "./PhoneNumberEditor.scss";
import DropDown from "../inputform/DropDown";
import Utilities from "../../foundation/Utility";
import Textbox from "../inputform/Textbox";

interface PhoneNumberEditorProps {
    value?: PhoneNumber;
    onChange?: (number: PhoneNumber) => void;
}

class PhoneNumberEditor extends React.Component<PhoneNumberEditorProps> {
    changed(number: PhoneNumber) {
        this.props.onChange && this.props.onChange(number);
    }
    changeEditNumberType(value: string) {
        this.changed({
            ...this.props.value,
            type: NumberTypes[value],
        });
    }
    changeEditNumberValue(value: string) {
        this.changed({
            ...this.props.value,
            phoneNumber: value,
        });
    }

    render(): React.ReactNode {
        return (
            <div className="phone-editor">
                <DropDown
                    noType={true}
                    value={this.props.value?.type}
                    options={Utilities.enumToOptions(NumberTypes)}
                    onChange={ev => this.changeEditNumberType(ev.target.value)}
                />
                <Textbox
                    type="tel"
                    autoComplete="tel"
                    fullWidth={true}
                    value={this.props.value?.phoneNumber ?? ""}
                    onChange={value => this.changeEditNumberValue(value)}
                />
            </div>
        );
    }
}

export default PhoneNumberEditor;
